import React, {useEffect} from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import GLightbox from "glightbox";
import 'glightbox/dist/css/glightbox.min.css';

import 'swiper/css';
import 'swiper/css/navigation';

import { Navigation } from "swiper/modules";

const Presentation = () => {
    useEffect(() => {
        const lightbox = GLightbox({
            selector: '.glightbox'
        });
    },[])
    return (
        <>
            <div className="slide" id="presentation">
                <div className="wrapper">
                    <div className="gauche">
                        <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
                            <SwiperSlide>
                                <a href="/images/galerie/videaste1.png" className={"glightbox"}>
                                    <img src={"/images/galerie/videaste1.png"} alt={"Image de la section Vidéaste | EPSE"} />
                                </a>
                            </SwiperSlide>
                            <SwiperSlide>
                                <a href="/images/galerie/videaste2.png" className={"glightbox"}>
                                    <img src={"/images/galerie/videaste2.png"} alt={"Image de la section Vidéaste | EPSE"} />
                                </a>
                            </SwiperSlide>
                            <SwiperSlide>
                                <a href="/images/galerie/videaste3.png" className={"glightbox"}>
                                    <img src={"/images/galerie/videaste3.png"} alt={"Image de la section Vidéaste | EPSE"} />
                                </a>
                            </SwiperSlide>
                            <SwiperSlide>
                                <a href="/images/galerie/videaste7.png" className={"glightbox"}>
                                    <img src={"/images/galerie/videaste7.png"} alt={"Image de la section Vidéaste | EPSE"} />
                                </a>
                            </SwiperSlide>
                            <SwiperSlide>
                                <a href="/images/galerie/videaste8.png" className={"glightbox"}>
                                    <img src={"/images/galerie/videaste8.png"} alt={"Image de la section Vidéaste | EPSE"} />
                                </a>
                            </SwiperSlide>
                            <SwiperSlide>
                                <a href="/images/galerie/videaste9.png" className={"glightbox"}>
                                    <img src={"/images/galerie/videaste9.png"} alt={"Image de la section Vidéaste | EPSE"} />
                                </a>
                            </SwiperSlide>
                            <SwiperSlide>
                                <a href="/images/galerie/videaste10.png" className={"glightbox"}>
                                    <img src={"/images/galerie/videaste10.png"} alt={"Image de la section Vidéaste | EPSE"} />
                                </a>
                            </SwiperSlide>
                            <SwiperSlide>
                                <a href="/images/galerie/videaste11.png" className={"glightbox"}>
                                    <img src={"/images/galerie/videaste11.png"} alt={"Image de la section Vidéaste | EPSE"} />
                                </a>
                            </SwiperSlide>
                            <SwiperSlide>
                                <a href="/images/galerie/videaste12.png" className={"glightbox"}>
                                    <img src={"/images/galerie/videaste12.png"} alt={"Image de la section Vidéaste | EPSE"} />
                                </a>
                            </SwiperSlide>
                            <SwiperSlide>
                                <a href="/images/galerie/videaste13.png" className={"glightbox"}>
                                    <img src={"/images/galerie/videaste13.png"} alt={"Image de la section Vidéaste | EPSE"} />
                                </a>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                    <div className="droite">
                        <div className="container">
                            <h1>
                                Formation
                            </h1>
                            <div className="texte">
                                <p>
                                    Notre formation de deux ans te plonge dans <span>toutes les étapes de création audiovisuelle</span> : écriture, tournage, son, montage.
                                </p>
                                <p>
                                    Encadré-e par notre équipe pédagogique, tu réaliseras des <span>projets concrets</span> comme un court métrage de <span>fiction</span> et un <span>documentaire</span>, mais tu seras aussi capable de créer toutes sortes de contenus pour les <span>réseaux sociaux</span>.
                                </p>
                                <p>
                                    Lors de ta deuxième année, tu auras l’occasion de présenter <span className="roll">un stage en entreprise de 5 à 7 semaines</span>, t’offrant une vraie expérience professionnelle et un premier pas dans le monde professionnel.
                                </p>
                               <p>
                                   Obtiens ton <span className="roll">certificat de qualification</span> en vidéaste et prépare-toi à exercer un métier créatif, technique et en <span>pleine évolution</span>, au croisement du cinéma, du web et de la communication visuelle !
                               </p>
                                <a href="https://www.epse.be/inscription" target='_blank' className="btn">Inscris-toi</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Presentation;